import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { PlatformType, getFilteredPlatforms } from '@/constants'

export type PlatformToggleItem = {
  value: PlatformType
  label: string
}

export const usePlatformItems = (
  supportedPlatforms: PlatformType,
): PlatformToggleItem[] => {
  const { t } = useTranslation()

  return useMemo((): PlatformToggleItem[] => {
    const filteredPlatforms = getFilteredPlatforms(supportedPlatforms)

    return filteredPlatforms.map((platform) => ({
      value: platform.value,
      label: t(platform.labelKey),
    }))
  }, [supportedPlatforms, t])
}

export default usePlatformItems
